<template>
  <div class="collection">
    <toolbar>
      <template v-slot:left>
        <div class="v-toolbar__text">
          {{ title }}
        </div>
      </template>
    </toolbar>

    <collection class="mt-2" :items="items" layout="vertical" />

    <v-powered-by-fitter />
  </div>
</template>

<script>
import { mapState } from "vuex"

import Collection from "@/components/Collection"

export default {
  components: {
    Collection,
    Toolbar: () => import("@/components/Toolbar")
  },

  props: {
    id: { type: Number, required: true },
    title: { type: String, required: true },
    items: { type: Array, required: true }
  },

  computed: {
    ...mapState(["global"]),

    showToolbar() {
      return !!this.global?.toolbar
    }
  }
}
</script>
